module.exports = __webpack_public_path__ + "static/media/bg-company.dbae332a.jpg";